var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 48C37.7548 48 48.5 37.2548 48.5 24C48.5 10.7452 37.7548 0 24.5 0C11.2452 0 0.5 10.7452 0.5 24C0.5 37.2548 11.2452 48 24.5 48Z",
    fill: "#3C5A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3037 7.3667H26.9871C23.8321 7.3667 20.3228 8.69367 20.3228 13.267C20.3382 14.8606 20.3228 16.3867 20.3228 18.1043H16.6729V23.9124H20.4358V40.6331H27.3503V23.8021H31.9141L32.327 18.088H27.2311C27.2311 18.088 27.2425 15.5461 27.2311 14.8079C27.2311 13.0006 29.1117 13.1041 29.2248 13.1041C30.1197 13.1041 31.8597 13.1067 32.3063 13.1041V7.3667H32.3037Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.88798ffd3901fe55c28a346689933619.svg";
export { ForwardRef as ReactComponent };